import { combineReducers } from 'redux';
import { flow, get } from 'lodash/fp';
import { selector as footerSelector } from 'components/Footer';
import { createCmsDuck } from 'helpers/cms';

export const STORE_KEY = 'layout';

export const cmsDuck = createCmsDuck({
  page: 'navigation-v3',
  path: [STORE_KEY, 'cms'],
  resultSelector: flow(get(['result', 'content']), JSON.parse),
});

export const footerDuck = createCmsDuck({
  page: '@footer-v2',
  path: [STORE_KEY, 'footer'],
  resultSelector: footerSelector,
});

export const dsbWidgetDuck = createCmsDuck({
  page: '@step1-main-form-classifieds',
  path: [STORE_KEY, 'dsbWidget'],
});

export const dsbBookingWidgetDuck = createCmsDuck({
  page: '@step1-booking-tab-classifieds',
  path: [STORE_KEY, 'dsbBookingWidget'],
});

export const gdprCookieBannerDuck = createCmsDuck({
  page: '@wkda/partials/cookie-banner/',
  query: { active: true },
  path: [STORE_KEY, 'gdprCookieBanner'],
  marketingCms: true,
});

export const reducer = combineReducers({
  cms: cmsDuck,
  footer: footerDuck,
  dsbWidget: dsbWidgetDuck,
  dsbBookingWidget: dsbBookingWidgetDuck,
  gdprCookieBanner: gdprCookieBannerDuck,
});
